export const fieldTypes = [
  {
    value: 'text',
    label: 'Single line of text (Text)',
  },
  {
    value: 'textarea',
    label: 'Multiple lines of text (Textarea)',
  },
  {
    value: 'select',
    label: 'Dropdown menu (Select)',
  },
  {
    value: 'checkbox',
    label: 'Multiple choice options (Checkbox)',
  },
  {
    value: 'radio',
    label: 'Single choice from options (Radio)',
  },
  {
    value: 'hidden',
    label: 'Information not visible to users (Hidden)',
  },
  {
    value: 'submit',
    label: 'Button to submit the form (Submit)',
  },
  {
    value: 'number',
    label: 'Numeric input field (Number)',
  },
  {
    value: 'date',
    label: 'Calendar date picker (Date)',
  },
  {
    value: 'file',
    label: 'Upload documents or images (File)',
  },
];
